import { gsap } from "gsap";
import Alpine from "alpinejs";

Alpine.data("spacer", () => ({
  init() {
    // console.log('spacer init')
  },
  destroy() {
    // console.log('spacer destroy')
  }
}));